import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={22.926}
      strokeWidth={1.2}
      d="M4.913 18.31c.427.87 1.305 2.075 1.958 2.77.472.502 1.296 1.037 2.02.898.852-.164 1.712-.766 2.885-.766s2.033.602 2.884.766c.724.139 1.548-.396 2.02-.898.654-.695 1.531-1.9 1.959-2.77 1.043-2.124 1.759-4.687 1.253-7.087-.443-2.103-1.991-3.887-4.152-4.3-1.535-.292-2.424.483-3.392.738m-1.516-.121c-.836-.316-1.683-.87-3.02-.616-2.406.458-5.743 4.042-2.777 7.015 1.695 1.7 5.016-.212 3.204-2.024-.95-.949-3.797 1.424.475 4.746"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={2.613}
      strokeWidth={1.2}
      d="M12.364 7.781c-.142-1.325-1.191-3.244-1.66-3.871-.49-.659-1.765-.16-.96 1.034.375.557 1.332 2.833 1.261 3.647"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={2.613}
      strokeWidth={1.2}
      d="M16.44 1.058a4.06 4.06 0 0 0-3.564 1.133 4.06 4.06 0 0 0-1.133 3.565c2.682.458 5.322-1.943 4.697-4.698"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={2.613}
      strokeWidth={1.2}
      d="M13.086 7.39c-1.221.6-1.755 1.776-3.54 1.23"
    />
  </svg>
);
export const NutritionistIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
